import api from './api';
import type { Plan, BillingInfo } from '@/types';

export const billingService = {
  async getPlans(): Promise<Plan[]> {
    const response = await api.get<{ plans: Plan[] }>('/api/billing/plans');
    return response.data.plans;
  },

  async getSubscription(orgId: string): Promise<BillingInfo> {
    const response = await api.get<BillingInfo>(`/api/billing/subscription/${orgId}`);
    return response.data;
  },

  async createCheckoutSession(orgId: string, plan: string): Promise<string> {
    const response = await api.post<{ url: string }>('/api/billing/create-checkout-session', {
      organization_id: orgId,
      plan,
    });
    return response.data.url;
  },

  async createPortalSession(orgId: string): Promise<string> {
    const response = await api.post<{ url: string }>('/api/billing/portal', {
      organization_id: orgId,
    });
    return response.data.url;
  },

  async cancelSubscription(orgId: string, atPeriodEnd: boolean = true): Promise<void> {
    await api.post(`/api/billing/subscription/${orgId}/cancel`, {
      at_period_end: atPeriodEnd,
    });
  },
};

export default billingService;
